<template>
  <div class="update-distribution-goods">
    <el-dialog title="SKU属性" :visible.sync="dialogVisible" @close="handleClose" width="900px">
      <div style="max-height: 600px; overflow: auto">
        <CategoryProps v-if="dialogVisible" propConfigType="sku" v-model="row.skuPropValues" :categoryIds="categoryIds"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CategoryProps from './CategoryProps.vue';

export default {
  components: {
    CategoryProps,
  },
  data() {
    return {
      dialogVisible: false,
      opts: {},
      row: {},
      categoryIds: [],
    };
  },
  methods: {
    method_open(opts) {
      this.dialogVisible = true;
      this.opts = opts
      this.row = opts.row || {};
      this.categoryIds = opts.categoryIds;

    },
    handleConfirm() {
      this.handleClose()
      this.opts.sureFn && this.opts.sureFn(this.row)
    },
    handleClose() {
      this.dialogVisible = false;
      this.categoryIds = []
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  padding-bottom: 20px;
}
</style>
